// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"3ab6e3c9","453":"0e65a26b","777":"dcb1b550"}[chunkId] + ".chunk.js";
};